// extracted by mini-css-extract-plugin
export var accordionItem = "component-module--accordionItem--8b9ac";
export var active = "component-module--active--c2be3";